import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import 'swiper/css';
import 'swiper/css/pagination';
import Hero6 from '../Hero/Hero6';
import Spacing from '../Spacing';
import Div from '../Div';
import Button from '../Button';
import SectionHeading from '../SectionHeading';



export default function PortfolioBubbleboy() {
  pageTitle('Creative After Dark');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const showcaseData = [
    {
      title: '',
      imgUrl: '/images/bubbleb0y.png',
      href: '',
    },
    {
      title: '',
      imgUrl: '/images/bubbleboy_1.png',
      href: '',
    },
    {
      title: '',
      imgUrl: '/images/bubbleboy_3.png',
      href: '',
    },

  ];

  return (
    <>
      <Hero6
        showcaseData={showcaseData}
      />
<Spacing lg='150' md='80'/>
      <Div className="container">
        <Spacing lg='90' md='40'/>
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading 
              title="Fan Expierience"
              subtitle= "KAMI presents BubbleBoy"
            >
              <Spacing lg='40' md='20'/>
              <p>KAMI presents Bubbleboy.</p>
              <Spacing lg='10' md='10'/>
              <p>We were tapped by KAMI, a renouned Chicago rapper to set up interactive displays and live stream the event. We offered a token gated approach for global fans to interact and view the concert IRL and across the web.</p>
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-lg-1">
            <Spacing lg='60' md='40'/>
            <h2 className='cs-font_30 cs-font_26_sm cs-m0'>Project Info -</h2>
            <Spacing lg='50' md='30'/>
            <Div className="row">
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>Category:</h3>
                <p className='cs-m0'>Fan Experience</p> 
                <Spacing lg='30' md='30'/>
              </Div>
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>Location:</h3>
                <p className='cs-m0'>WNDR Museum, Chicago</p>
                <Spacing lg='30' md='30'/>
              </Div>
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>Date:</h3>
                <p className='cs-m0'>07-Jul-2023</p>
                <Spacing lg='30' md='30'/>
              </Div>
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>Client:</h3>
                <p className='cs-m0'>KAMI, Wolve Productions</p>
                <Spacing lg='30' md='30'/>
              </Div>
            </Div>
          </Div>
        </Div>
        <Spacing lg='65' md='10'/>
          <Div className="cs-page_navigation cs-center">
            <Div>
              <Button btnLink='/portfolio/pasuma' btnText='Prev Project' variant='cs-type1'/> 
            </Div>
            <Div>
              <Button btnLink='/portfolio/galacticos' btnText='Next Project'/>
            </Div>
          </Div>
      </Div>
    </>
  );
}
